


<div class="layout-preloader-container" >
    <div class="layout-preloader">
        <span>
            <router-outlet></router-outlet>
        </span>
    </div>
</div>